import "./css/Navbar.css";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { IconContext } from "react-icons";
import { RxHamburgerMenu } from "react-icons/rx";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  // Alle Navigationslinks zentral definiert
  const navLinks = [
    { to: "/", label: "Start" },
    { to: "/termine", label: "Termine" },
    { to: "/teams", label: "Teams" },
    { to: "/information", label: "Informationen" },
    { to: "/verein", label: "Verein" },
    { to: "/uebungen", label: "Training" },
    { to: "/impressum", label: "Impressum" },
  ];

  // Desktop Links
  const renderDesktopLinks = () =>
    navLinks.map((link) => (
      <Link key={link.to} to={link.to} className="NavbarLink">
        {link.label}
      </Link>
    ));

  // Mobile Links
  const renderMobileLinks = () =>
    navLinks.map((link) => (
      <Link
        key={link.to}
        to={link.to}
        className="NavbarLink"
        onClick={toggleMenu}
      >
        {link.label}
      </Link>
    ));

  return (
    <div className="selectNavbar">
      {/* Desktop Menü */}
      <div className="FlexRow desktopMenu">
        <div className="mainLogo">
          <Link to="/">
            <img src="img/logo/logo.svg" alt="mainLogo" />
          </Link>
        </div>
        <div className="FlexRow NavbarLinks">{renderDesktopLinks()}</div>
      </div>

      {/* Mobile Menü */}
      <div className="FlexRow mobileMenu">
        <div className="mainLogo">
          <Link to="/">
            <img
              src="img/logo/logo.svg"
              className="mainLogoIMG"
              alt="mainLogo"
            />
          </Link>
        </div>

        <IconContext.Provider value={{ className: "shared-class", size: 32 }}>
          <RxHamburgerMenu
            className="icon navbarExtend"
            onClick={toggleMenu}
          />
        </IconContext.Provider>

        {/* Overlay Menü für mobile Ansicht */}
        <div className={`mobileNavOverlay ${isMenuOpen ? "open" : ""}`}>
          <div className="overlayContent">{renderMobileLinks()}</div>
        </div>

        {/* Halbtransparenter Hintergrund */}
        {isMenuOpen && <div className="backdrop" onClick={toggleMenu}></div>}
      </div>
    </div>
  );
};

export default Navbar;
